module.exports = __webpack_public_path__ + "static/img/center-bottom-title-icon.c3061d0c.png";